export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.16-1400.36",
  commitId: "044f627de89d15a01a552f7a177f396db27e0666",
  commitTime: "2026-09-16T14:00:36.000Z",
});
